import { useState, useRef } from "react";
import styled from "styled-components";
import { Paper, Grid, Box, Toolbar } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { AccordionItem } from "./components/AccordionItem";
import {
  ButtonSubmit,
  ButtonCancel,
  SearchInput,
  Select,
  Loading,
} from "components/shared";

import { TableDownload } from "components/tables";
import { useAddreesse } from "hooks";
import { IOrder, IAddressee } from "config/interfaces";
// import { TableTitle } from "./styles";
// import { getAddreessesStatusDescription } from "utils";
// import ListInstallsContext from "context/ListInstallsContext";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    searchInput: {
      width: "50%",
    },
    toolbar: {
      paddingBottom: theme.spacing(2),
      borderRadius: "4px",
      background: "var(--backgroundContent)",
      width: "100%",
      "& .MuiToolbar-regular": {
        padding: 0,
      },
    },
    table: {
      borderRadius: "4px",
      background: "var(--backgroundContent)",
      width: "100%",
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      maxWidth: "calc(100% - 12px)",
    },
    input: {
      "& .MuiInputBase-input": {
        boxShadow: "none",
        fontSize: "1.2rem",
        fontWeight: "500",
        textTransform: "uppercase",
      },
    },
    checkbox: {
      "&.MuiCheckbox-colorSecondary.Mui-checked": {
        color: "var(--orange)",
      },
      "& .MuiSvgIcon-root": {
        width: "1.4rem",
      },
    },
    "@media (max-width: 600px)": {
      searchInput: {
        width: "100%",
      },
    },
  })
);
interface TableProps {
  title?: string;
}

const filters: IOrder.SelectField[] = [
  {
    label: "GRUPO",
    value: "group",
  },
  // {
  //   label: "STATUS",
  //   value: "status",
  // },
];

// interface HeadCell {
//   disableSorting?: boolean;
//   id: keyof IAddressee.Table;
//   label: string;
// }

// TABLE HEAD
// const headCells: HeadCell[] = [
//   { id: "NMUSUARIO", label: "NOME" },
//   { id: "TELEFONE", label: "TELEFONE" },

//   { id: "ENDECOMPL", label: "COMPLEMENTO" },
//   { id: "DSGRUPOUSUARIO", label: "GRUPO" },
//   // { id: "STAPP", label: "STATUS APLICATIVO" },
// ];

const SelectedItems = styled.span`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1.2rem;
`;

interface DataState {
  filter: string | null;
  status?: string;
  group?: string;
}

const initialState: DataState = {
  filter: null,
  status: "2",
  group: "0",
};

export default function NewAddresseesTemplate({ title }: TableProps) {
  const [data, setData] = useState(initialState);

  // rows é onde fica a lista
  const [search, setSearch] = useState("");

  const {
    loading,
    addreesses,
    groupOptions,
    getAddreessesByFilters,
    getAllAddreesses,
    IDMCM,
  } = useAddreesse();

  let inputSearchRef = useRef<HTMLInputElement | null>(null);

  const classes = useStyles();

  const filterItens = (list: IAddressee.Addressee[]) => {
    if (!search) return addreesses;
    const filter = list.filter(
      (item) =>
        item.NMUSUARIO.toLowerCase().includes(search.toLowerCase()) ||
        item.TELEFONE.toLowerCase().includes(search.toLowerCase()) ||
        item.ENDECOMPL.toLowerCase().includes(search.toLowerCase())
    );
    return filter;
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, checked } = event.target;

    const newState = { ...data, [name]: value ? value : checked };
    setData(newState);
  };

  const handleFilterClick = () => {
    // setPage(0);
    switch (data.filter) {
      case "status":
        return getAddreessesByFilters({ IDSTAPP: data.status });
      case "group":
        return getAddreessesByFilters({
          // FLUSERADM: data.group === "ADMINISTRADOR" ? 1 : 0,
          FLUSERADM: data?.group as any,
        });
      default:
        return;
    }
  };

  const handleCancelFilter = () => {
    setData({ ...data, filter: null });
    setSearch("");
    getAllAddreesses();
  };

  return (
    <>
      {IDMCM && (
        <>
          <Paper className={classes.toolbar} elevation={0}>
            <Toolbar>
              <Grid container spacing={2} justifyContent="space-between">
                <Grid className={classes.searchInput}>
                  <SearchInput
                    ref={inputSearchRef}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="POR NOME / TELEFONE / COMPLEMENTO"
                  />
                </Grid>

                <Grid alignItems="flex-end">
                  <Box display="flex" justifyContent="flex-end">
                    {addreesses.length > 0 && (
                      <TableDownload
                        dataToConvert={addreesses.sort((a: any, b: any) =>
                          a.NMUSUARIO > b.NMUSUARIO ? 1 : -1
                        )}
                        type="destinatarios"
                      />
                    )}
                    <Select
                      type="mainSelect"
                      label="FILTRO"
                      name="filter"
                      choices={filters}
                      value={data.filter}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Toolbar>

            {data.filter && (
              <Toolbar id="toolbar-period" style={{ marginTop: "16px" }}>
                <Grid container spacing={2} justifyContent="flex-end">
                  <Grid item xs={12} md={6}>
                    <Paper style={{ padding: "16px" }}>
                      {data.filter === "group" && (
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={3}>
                            <Select
                              label="GRUPO"
                              name="group"
                              choices={groupOptions}
                              value={data.group}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                      )}

                      {/* {data.filter === "status" && (
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={3}>
                            <Select
                              label="STATUS"
                              name="status"
                              choices={statusOptions}
                              value={data.status}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                      )} */}

                      <Box mt={3} display="flex" justifyContent="flex-end">
                        <ButtonCancel
                          onClick={handleCancelFilter}
                          style={{ marginRight: "16px" }}
                        >
                          LIMPAR
                        </ButtonCancel>
                        <ButtonSubmit autoFocus onClick={handleFilterClick}>
                          FILTRAR
                        </ButtonSubmit>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Toolbar>
            )}
          </Paper>

          {!loading ? (
            <Paper className={classes.table} elevation={0}>
              <Grid container alignItems="center">
                <Grid item xs={12} sm={6}>
                  <Box display="flex" alignItems="center" minHeight={48}>
                    <SelectedItems>
                      Existem {filterItens(addreesses).length} registros
                    </SelectedItems>
                    {/* {selectedItems && actions?.isAllow ? (
                  <ul style={{ display: "inline", marginLeft: "8px" }}>
                    {actions.inactivate && (
                      <Tooltip title="INATIVAR">
                        <IconButton onClick={() => setOpenInactivate(true)}>
                          {" "}
                          <Icons.Disable
                            style={{ fontSize: "20px", color: "var(--orange)" }}
                          />{" "}
                        </IconButton>
                      </Tooltip>
                    )}

                    {actions.delete && (
                      <Tooltip title="EXCLUIR">
                        <IconButton onClick={() => setOpenDelete(true)}>
                          {" "}
                          <Icons.Delete
                            style={{ fontSize: "20px", color: "var(--red)" }}
                          />{" "}
                        </IconButton>
                      </Tooltip>
                    )}

                    {selectedRows.length === 1 && (
                      <Tooltip title="EDITAR">
                        <IconButton
                          onClick={() =>
                            router.push(
                              `/destinatarios/${selectedRows[0].IDUSUARIO}/editar`
                            )
                          }
                        >
                          <Icons.Edit
                            style={{ fontSize: "20px", color: "var(--blue)" }}
                          />
                        </IconButton>
                      </Tooltip>
                    )}

                    {actions.activate && (
                      <Tooltip title="REATIVAR">
                        <IconButton onClick={() => setOpenActivate(true)}>
                          {" "}
                          <Icons.Activate
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "var(--iconGreen)",
                            }}
                          />{" "}
                        </IconButton>
                      </Tooltip>
                    )}
                  </ul>
                ) : null} */}
                  </Box>
                </Grid>
              </Grid>

              {/* conteudo aqui */}
              <div style={{ marginTop: "20px" }}>
                {filterItens(addreesses).map((people: any, index: number) => (
                  <Paper elevation={1} style={{ marginTop: "20px" }}>
                    <AccordionItem
                      // isOpen={isOpen}
                      key={index}
                      index={index}
                      data={people}
                      // editUser={(values: any) => editUser(values)}
                      // deleteUser={(values: any) => deleteUser(values)}
                    />
                  </Paper>
                ))}
              </div>
            </Paper>
          ) : (
            <Box mt={15} mb={15}>
              <Loading />
            </Box>
          )}
        </>
      )}
    </>
  );
}
